export default __webpack_public_path__ + "static/media/image.a3291c7a.png";